<template>
  <div class="sidebar-right" :class="{ 'hidden': hidden, selected: selectedMobileOption == 'overview' }">
    <div id="viewer-action-details" class="viewer-action-details"><slot></slot></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: function() {
    return  { hidden: false };
  },
  methods: {
    hide: function() { this.hidden = true },
    show: function() { this.hidden = false },
    toggle: function() { this.hidden = !this.hidden }
  },
  computed: {
    ...mapState(['selectedMobileOption'])
  }
}
</script>

<style lang="scss" scoped>
  .sidebar-right {
    &.hidden {
      visibility: hidden;
    }
  }

  @media (max-width: 767px) {
    .sidebar-right {
      display: none;

      &.selected {
        display: block;
      }
    }
}
</style>
